"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataVariableTypes;
(function (DataVariableTypes) {
    DataVariableTypes["BOOLEAN"] = "BOOLEAN";
    DataVariableTypes["NUMBER"] = "NUMBER";
    DataVariableTypes["TEXT"] = "TEXT";
})(DataVariableTypes = exports.DataVariableTypes || (exports.DataVariableTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0YVZhcmlhYmxlVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZXZhbHVhdG9yL21vZGVscy9EYXRhVmFyaWFibGVUeXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQVksaUJBSVg7QUFKRCxXQUFZLGlCQUFpQjtJQUMzQix3Q0FBbUIsQ0FBQTtJQUNuQixzQ0FBaUIsQ0FBQTtJQUNqQixrQ0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQUpXLGlCQUFpQixHQUFqQix5QkFBaUIsS0FBakIseUJBQWlCLFFBSTVCIn0=